export default __webpack_public_path__ + "static/media/registered1.e0018b67.png";